import { Alert, Typography, Button, Tooltip, Box, Chip } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SettingsIcon from '@mui/icons-material/Settings';
import HomeIcon from '@mui/icons-material/Home';
import PhoneIcon from '@mui/icons-material/Phone';
import { usePeriodo } from '../context/PeriodoContext';

interface PeriodoIndicatorProps {
  onOpenParametrizacion: () => void;
  tipoComision: 'Asesor' | 'Jefatura' | 'Líder';
}

export default function PeriodoIndicator({ onOpenParametrizacion, tipoComision }: PeriodoIndicatorProps) {
  const { fechaInicio, fechaFin, fechaInicioCallCenter, fechaFinCallCenter } = usePeriodo();

  // Formatear fechas para mostrar
  const formatFecha = (fecha: string) => {
    const date = new Date(fecha + 'T00:00:00');
    return date.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      icon={<CalendarMonthIcon />}
      action={
        <Tooltip title="Cambiar períodos en Parametrización → Períodos">
          <Button
            color="inherit"
            size="small"
            startIcon={<SettingsIcon />}
            onClick={onOpenParametrizacion}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Cambiar Períodos
          </Button>
        </Tooltip>
      }
    >
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
        Períodos de cálculo configurados para {tipoComision}:
      </Typography>

      {/* Período HOME */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
        <Chip
          icon={<HomeIcon />}
          label="HOME"
          size="small"
          color="primary"
          variant="outlined"
          sx={{ fontWeight: 600 }}
        />
        <Typography variant="body2">
          <strong>{formatFecha(fechaInicio)}</strong> hasta <strong>{formatFecha(fechaFin)}</strong>
        </Typography>
      </Box>

      {/* Período CALL CENTER */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Chip
          icon={<PhoneIcon />}
          label="CALL CENTER"
          size="small"
          color="secondary"
          variant="outlined"
          sx={{ fontWeight: 600 }}
        />
        <Typography variant="body2">
          <strong>{formatFecha(fechaInicioCallCenter)}</strong> hasta <strong>{formatFecha(fechaFinCallCenter)}</strong>
        </Typography>
      </Box>

      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
        Para cambiar los períodos, ve a Parametrización → pestaña "Períodos"
      </Typography>
    </Alert>
  );
}
